import { BaseModel } from "./base-model";
import { TerminalInfo, PortInfo, Region } from "./types/terminals-model.types";
import { VesselInfo } from "./types/vessels-model.types";
import { ShoreContextInternalCache } from "./types/voyage-shore-context-model.types";

export abstract class VoyageShoreContextModelBase extends BaseModel {
  abstract get vessels(): VesselInfo[];
  abstract get terminals(): TerminalInfo[];
  abstract get terminalsMap(): Map<string, TerminalInfo>;
  abstract get ports(): Map<string, PortInfo>;
  abstract get regions(): Region[] ;
  abstract get services(): Array<string>;
  abstract get servicesMap(): Map<string, Array<number>>;
  abstract get operators(): Array<string>;
  abstract get operatorsMap(): Map<string, Array<number>>;
  abstract get shouldUpdateFilterMapView(): boolean;
  abstract setShouldUpdateFilterMapView(shouldUpdate: boolean): void;
  abstract setClearFilters(): void;
  abstract toggleTimeLineView(): void;
  abstract toggleVesselSelection(): void;

  protected abstract _cache: ShoreContextInternalCache
}

let VoyageShoreContextModel: VoyageShoreContextModelBase | null = null;

function setVoyageShoreContextModel(model: VoyageShoreContextModelBase) {
  VoyageShoreContextModel = model;
}

export { VoyageShoreContextModel, setVoyageShoreContextModel };
